module.exports = __webpack_public_path__ + "img/step-reward.454d275f.png";